
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/about/standard-terms-for-services",
      function () {
        return require("private-next-pages/about/standard-terms-for-services.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/about/standard-terms-for-services"])
      });
    }
  